import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import useRestoreBackup from "api/api-hooks/cloud/backups/useRestoreBackup";
import useDeleteBackup from "api/api-hooks/cloud/backups/useDeleteBackup";
import { AppConfirm } from "utils/PopupUtil";

export default function BackupOptions({ backupID, backupDate }) {
  const { restoreBackup, restoringBackup } = useRestoreBackup();
  const { deleteBackup, deletingBackup } = useDeleteBackup();

  const onRestore = async () => {
    const result = await AppConfirm({
      title: "Confirm Restoration",
      text: "Are you sure you want to restore this backup?",
      confirmButtonText: "Restore",
      confirmButtonColor: "var(--primary)",
    });

    if (!result.isConfirmed) return;

    restoreBackup({ backupID: backupID, backupDate: backupDate });
  };

  const onDelete = async () => {
    const result = await AppConfirm({
      title: "Delete Backup?",
      text: "Are you sure you want to delete this backup?",
    });

    if (!result.isConfirmed) return;

    deleteBackup({ backupID: backupID });
  };

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Restore"
        icon="mdi mdi-restore"
        onClick={onRestore}
        disabled={restoringBackup || deletingBackup}
      />
      <DropdownOptionWithIcon
        name="Delete"
        icon="mdi mdi-delete"
        onClick={onDelete}
        disabled={restoringBackup || deletingBackup}
      />
    </PopoverDropdownMenu>
  );
}
